"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
const mapMetaOptions = (oldOptions, newOptions, mappingMetaOptions = {
    fieldMap: {},
    oldFontUnit: 'rem',
    newFontUnit: 'px',
    changeUnit: null,
}) => {
    const { fieldMap, oldFontUnit, newFontUnit, changeUnit } = mappingMetaOptions;
    const mergedOptions = newOptions;
    Object.keys(newOptions).forEach((key) => {
        if (key in oldOptions && oldOptions[key]) {
            mergedOptions[key] = oldOptions[key];
        }
        else if (fieldMap[key] && oldOptions[fieldMap[key]]) {
            mergedOptions[key] = oldOptions[fieldMap[key]];
        }
        if (changeUnit && mergedOptions[key] && mergedOptions[key].toString().endsWith(oldFontUnit)) {
            const fontSize = mergedOptions[key].split(oldFontUnit)[0];
            mergedOptions[key] = changeUnit(parseFloat(fontSize)).toString() + newFontUnit;
        }
    });
    return mergedOptions;
};
exports.default = mapMetaOptions;
//# sourceMappingURL=map-meta-options.js.map